import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import router from './router'
import App from './App.vue'

//npm install vue-i18n socket.io-client dayjs
// 样式
import '@/styles/index.scss'

// 插件
import elementPlusPlugin from '@/plugins/element-plus'
import directives from '@/directives'

// 国际化
import { createI18n } from 'vue-i18n'
import zhCN from '@/locales/zh-CN.json'
import enUS from '@/locales/en-US.json'

// 创建应用
const app = createApp(App)

// 创建Pinia
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)



// 创建i18n实例
const i18n = createI18n({
  locale: localStorage.getItem('language') || 'zh-CN',
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  },
  legacy: false
})

// 注册插件
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(elementPlusPlugin)
//app.use(ElementPlus)
// 设置全局守卫
setupGlobalGuards(router)
// 注册全局指令
for (const [key, directive] of Object.entries(directives)) {
  app.directive(key, directive)
}

// 全局错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue错误:', err, info)

  // 可以在这里发送错误到监控服务
  if (process.env.NODE_ENV === 'production') {
    // 生产环境错误处理
  }
}

// 忽略浏览器无害的 ResizeObserver 循环通知警告：
// el-select 下拉、el-table 等组件在布局变化时可能触发
// "ResizeObserver loop completed with undelivered notifications"，
// 该警告会被 webpack-dev-server 的错误遮罩捕获并弹错，实际不影响功能。
// 使用捕获阶段拦截，阻止其继续传播到其他 error 监听器。
const resizeObserverLoopErrRe = /ResizeObserver loop completed with undelivered notifications/
window.addEventListener('error', (event) => {
  if (event && resizeObserverLoopErrRe.test(event.message || '')) {
    event.stopImmediatePropagation()
  }
}, true)

// 全局属性
app.config.globalProperties.$filters = {
  formatDate(date) {
    if (!date) return ''
    return new Date(date).toLocaleDateString()
  },
  formatDateTime(date) {
    if (!date) return ''
    return new Date(date).toLocaleString()
  },
  truncate(text, length = 100) {
    if (!text) return ''
    if (text.length <= length) return text
    return text.substring(0, length) + '...'
  }
}

// 挂载应用
app.mount('#app')

// 初始化用户信息 - 改进版本
import { useAuthStore } from './stores/auth'
import { setupGlobalGuards } from "@/router/guards";

const initApp = async () => {
  console.log('开始初始化应用...')

  try {
    const authStore = useAuthStore()

    // 等待初始化完成
    const user = await authStore.init()

    if (user) {
      console.log('应用初始化完成，用户已登录:', user.username)

      // 派发初始化完成事件，供其他组件监听
      window.dispatchEvent(new CustomEvent('app-initialized', {
        detail: { user }
      }))

    } else {
      console.log('应用初始化完成，用户未登录')
    }
  } catch (error) {
    console.error('应用初始化失败:', error)
  }
}

// 调用初始化
initApp().then(r => {})


// 开发环境热重载
if (process.env.NODE_ENV === 'development') {
  // Vue CLI 已经自动处理热重载，不需要手动配置
  // 如果有需要，可以添加自定义热重载逻辑
}

// 性能监控
if (process.env.NODE_ENV === 'production') {
  // 监控首次内容绘制时间
  const observer = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      console.log('FCP时间:', entry.startTime)
    }
  })

  observer.observe({ entryTypes: ['paint'] })
}